import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PayrollNavbar, { NavbarItemProps } from '../../../components/ProfileInnerNavbar';
import { useTranslation } from 'react-i18next';
import { Roles } from '@/components/roles';
import { useComplianceCountry } from '../../../hooks/useComplianceCountry';
import type { RootState } from '../../../store/redux/store/store';

export default ({ children }: any) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const complianceCountry = useComplianceCountry();
  const loggedInUserId = useSelector((state: RootState) => state.user.userId);
  const selectedUser = useSelector((state: RootState) => state.user.selectedUser);
  const isOwnProfile = id === loggedInUserId;
  const isSaudiEmployee = !!selectedUser?.saudiNationalIdNumber;
  const showBenefitsForEmployee = isOwnProfile && complianceCountry === 'KSA' && !isSaudiEmployee;
  // EOS + Final Settlement are HR-owned tools (Admin is NOT HR — see CLAUDE.md Role Model). An employee
  // — including an Admin, who is also an employee — may read their OWN record (self-service). Route guard
  // + `isHr` inside each page keep viewing-others and all mutations HR-only.
  const showEosForEmployee = isOwnProfile;

  const navbarItems: NavbarItemProps[] = [
    { id: 'payrollmonth', content: t('ACTIVE PAYROLL MONTH'), to: `/profile/${id}/payroll/active-payroll-month`, roles: Roles.CLOCKING },
    { id: 'salaryConfiguration', content: t('SALARY CONFIGURATION'), to: `/profile/${id}/payroll/salary-configuration`, roles: Roles.HR },
    // Hourly pay (docs/hourly-pay-spec.md §3.1/§3.2): pay basis + rate history. Salary data, so HR
    // only — including on the employee's own profile (the route is HR_ONLY_ROLES in App.tsx).
    { id: 'hourlyPay', content: t('HOURLY PAY'), to: `/profile/${id}/payroll/hourly-pay`, roles: Roles.HR },
    { id: 'variablePay', content: t('VARIABLE PAY'), to: `/profile/${id}/payroll/variable-pay`, roles: Roles.HR },
    { id: 'adjustments', content: t('ADJUSTMENTS'), to: `/profile/${id}/payroll/adjustments`, roles: Roles.HR },
    { id: 'benefits', content: t('BENEFITS'), to: `/profile/${id}/payroll/benefits`, roles: showBenefitsForEmployee ? Roles.CLOCKING : Roles.HR },
    { id: 'payHistory', content: t('PAY HISTORY'), to: `/profile/${id}/payroll/pay-history`, roles: Roles.CLOCKING },
    { id: 'endOfService', content: t('END OF SERVICE'), to: `/profile/${id}/payroll/end-of-service`, roles: showEosForEmployee ? Roles.CLOCKING : Roles.HR },
    { id: 'finalSettlement', content: t('FINAL SETTLEMENT'), to: `/profile/${id}/payroll/final-settlement`, roles: showEosForEmployee ? Roles.CLOCKING : Roles.HR },
    { id: 'payslips', content: t('PAYSLIPS'), to: `/profile/${id}/payroll/payslips`, roles: Roles.CLOCKING },
  ];

  return (
    <div className="mt-4">
      <PayrollNavbar items={navbarItems} primaryColor={"var(--mowazaf-primary)"} />
      <div className="mt-4 p-4">
        {children}
      </div>
    </div>
  );
};

